import React from 'react';
import Urjanet from './Urjanet';

export default function UtilityContainer(props) {
  return (
    <>
      <Urjanet
        requestId={props.requestId}
        onCompleted={props.onNextStep}
        createScoringRequest={props.createScoringRequest}
      />
      <button
        type="button"
        className="btn btn-secondary"
        onClick={() => props.onNextStep(props.history, props.location.state)}
        data-cy="nextButton"
      >
        Next
      </button>
    </>
  );
}
